import moment from 'moment';

export const batchStatuses = {
  closed: 'Fechado',
  sent: 'Enviado',
  analyzed: 'Analisado',
  in_appeal: 'Em recurso',
  settled: 'Baixado',
  canceled: 'Cancelado',
};

export const batchStatusClasses = {
  closed: 'bg-pill-outline',
  sent: 'bg-pill-amber',
  analyzed: 'bg-pill-blue',
  in_appeal: 'bg-pill-amber',
  settled: 'bg-pill-green',
  canceled: 'bg-pill-gray',
};

export const guideTypes = {
  consultation: 'Consulta',
  sadt: 'SP/SADT',
  simple: 'Guia simples',
};

export function idOf(doc) {
  if (!doc) return null;
  // eslint-disable-next-line no-underscore-dangle
  const id = doc.id || doc._id;
  return id ? String(id) : null;
}

export function round2(value) {
  return Math.round((Number(value) || 0) * 100) / 100;
}

export function num(value) {
  return Number(value) || 0;
}

export function splitProportional(total, weights) {
  const sum = weights.reduce((acc, weight) => acc + num(weight), 0);
  const amount = round2(total);
  if (sum <= 0 || weights.length === 0) {
    return weights.map(() => 0);
  }
  const shares = weights.map(weight => round2((amount * num(weight)) / sum));
  const distributed = shares.reduce((acc, share) => acc + share, 0);
  const rest = round2(amount - distributed);
  if (rest !== 0) {
    shares[shares.length - 1] = round2(shares[shares.length - 1] + rest);
  }
  return shares;
}

export function transferEffect({
  amount, glossedAmount, recoveredAmount, insurance, value,
}) {
  const base = num(insurance);
  if (base <= 0 || num(amount) <= 0 || num(value) <= 0) return 0;
  const effect = round2((num(amount) * num(value)) / base);
  const limit = round2(num(amount) - num(glossedAmount) + num(recoveredAmount));
  return Math.max(Math.min(effect, Math.max(limit, 0)), 0);
}

export function recoveryEffect({ amount, insurance, value }) {
  const base = num(insurance);
  if (base <= 0 || num(amount) <= 0 || num(value) <= 0) return 0;
  return round2((num(amount) * num(value)) / base);
}

export function deadlineInfo(deadline) {
  if (!deadline || !deadline.at) {
    return {
      tone: 'none',
      label: 'Sem prazo',
      hint: deadline && deadline.configured ? 'lote ainda não enviado' : 'configure no convênio',
      days: null,
      at: null,
    };
  }
  const days = Number(deadline.days);
  const at = moment(deadline.at).format('DD/MM/YYYY');
  if (days < 0) {
    const late = Math.abs(days);
    return {
      tone: 'overdue',
      label: `Vencido há ${late} ${late === 1 ? 'dia' : 'dias'}`,
      hint: `venceu em ${at}`,
      days,
      at,
    };
  }
  if (days === 0) {
    return {
      tone: 'soon', label: 'Vence hoje', hint: `até ${at}`, days, at,
    };
  }
  if (days === 1) {
    return {
      tone: 'soon', label: 'Vence amanhã', hint: `até ${at}`, days, at,
    };
  }
  return {
    tone: days <= 14 ? 'soon' : 'ok',
    label: `${days} dias`,
    hint: `até ${at}`,
    days,
    at,
  };
}

export function guideLabel(guide) {
  const number = (guide && (guide.referral?.provider || guide.code)) || '';
  return number ? `Guia ${number}` : 'Guia';
}

export function itemLabel(item) {
  const expense = (item && item.expense) || {};
  return [expense.code, expense.name].filter(Boolean).join(' ');
}

export function fileSize(bytes) {
  const size = num(bytes);
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function fillTemplate(text, context = {}) {
  return String(text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => {
    const value = context[key];
    return value === undefined || value === null ? match : String(value);
  });
}
